import Vue from 'vue'
export default {
  setQueryParams(state, params) {
    state.queryParams = params
  },
  setQuerySearch(state, params) {
    state.querySearch = params
  },
  setActiveStickySearchBar(state, active) {
    state.activeStickySearchBar = active
  },
  setSearchTerm(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  setResults(state, searchResults) {
    state.searchResults = searchResults
  },
  seResultFilter(state, searchFilter) {
    state.searchFilter = searchFilter
  },
  setResultSelected(state, searchSelected) {
    state.searchSelected[searchSelected.key] = searchSelected.value
  },
  setHotel(state, hotel) {
    Vue.set(state, 'hotel', hotel)
  },
  setErrors(state, errors) {
    Vue.set(state, 'errors', errors)
  },
  modifyError(state, error) {
    if (error.add) state.errors.total = state.errors.total + 1
    if (error.type && error.object) state.errors[error.type] = error.object
  },
  setInstance(state, obj) {
    Vue.set(state, 'instances', obj)
  },
  addParamInstance(state, { parent, key, value }) {
    state.instances[parent][key] = value
  },
  setModule(state, module) {
    state.module = module
  },
  setOptionsCalendar(state, options) {
    state.optionsCalendar[options.key] = options.value
  },
  addSticky(state, sticky, type) {
    state.sticky.push(sticky)
  },
  removeSticky(state, sticky) {
    state.sticky.splice(state.sticky.indexOf(sticky), 1)
  },
  setPaths(state, paths) {
    state.paths = paths
  },
  setExternalRedirect(state, externalRedirect) {
    state.externalRedirect = externalRedirect
  }
}
